import { FC } from 'react';

import OrganizationsTable from 'shared/components/Table/AdminOrgTable';

import styles from './OrgListContent.module.scss';

const OrgListContent: FC = () => {
	return (
		<div className={styles.container}>
			<OrganizationsTable />
		</div>
	);
};

export default OrgListContent;
